import {
	useEffect,
	useState,
	Children,
	type FunctionComponent,
	type PropsWithChildren,
	type ReactElement,
} from "react";

import "./TabPanel.scss";



export declare type TabPanelProps = PropsWithChildren<{
	activeIdx?: number;
	defaultActive?: string;
}>;



export const TabPanel: FunctionComponent<TabPanelProps> = ({
	activeIdx,
	children,
}: TabPanelProps ) => {

	const [ activeTabIdx, setActiveTabIdx, ] = useState(-1);

	const routes = [];

	const tabs = Children.toArray(children).map<[number, string, any]>((child: any, idx) => {
		if("props" in child && "route" in child.props) {
			routes.push([idx, child.props.route]);
		}
		if("props" in child && "label" in child.props) {
			return [ idx, child.props.label, child, ];
		}
		throw new Error("invalid tab found...");
	});

	useEffect(() => {
		if(routes.length) {
			const { pathname, } = window.location;
			const route = routes.find(([idx, route]) => pathname === route);
			if( route ) {
				setActiveTabIdx(route[0]);
				return;
			}
		}
		setActiveTabIdx(activeIdx ? activeIdx : 0);
	}, []);


	const onActivateTab = idx => evt => {
		const route = routes.find(([ridx, route]) => ridx === idx);
		if( route ) {
			const { origin, } = window.location;
			const { history, document, } = window;
			history.replaceState(null, document.title, `${origin}${route[1]}`);
		}
		setActiveTabIdx(idx);
	}


	const renderActiveView = ():ReactElement => {
		if(activeTabIdx !== -1 ) {
			const active = tabs.find(([idx]) => idx === activeTabIdx);
			if( active ) {
				return active[2];
			}
			throw new Error(`failed activating view "${activeIdx}"`);
		}
		return <div />;
	}

	const tabClasses = ( active: boolean, ) => [ "tab", active ? "active" : "inactive" ].join(" ");

	return (
		<div className="tab-panel">
			<div className="tabs">
			{
				tabs.map(([idx, label, Tab], ) => {
					return (
						<div
							className={tabClasses(idx === activeTabIdx)}
							key={idx}
							onClick={onActivateTab(idx)}>
								<p>{label}</p>
						</div>
					);
				})
			}
			</div>
			<div className="view">
				{renderActiveView()}
			</div>
		</div>
	);

}
